import HeadingArt from './HeadingArt';

export const internalArt = {
  home: 'wallet', goals: 'goal', kids: 'family', history: 'history', profile: 'person',
  dashboard: 'receipt', buys: 'silver', sells: 'silver', barbuy: 'bar', goldbuy: 'gold', copperbuy: 'bar', bars: 'bar',
  settlements: 'receipt', charges: 'wallet', withdrawals: 'wallet', ibans: 'shield', deliveries: 'delivery',
  tickets: 'support', users: 'person', logs: 'history', settings: 'shield',
  buy: 'silver', sell: 'silver', buybar: 'bar', sellbar: 'bar', buygold: 'gold', sellgold: 'gold', buycopper: 'bar', sellcopper: 'bar',
  transfer: 'receipt', delivery: 'delivery', charge: 'wallet', withdraw: 'wallet',
};

export function titleArt(title = '') {
  if (/رمز|هویت|مدیر|تنظیم|حساب بانکی/.test(title)) return 'shield';
  if (/هدف/.test(title)) return 'goal';
  if (/کیف|شارژ|برداشت/.test(title)) return 'wallet';
  if (/تحویل|آدرس|نشانی/.test(title)) return 'delivery';
  if (/تیکت|پیام|پشتیبان|اعلان/.test(title)) return 'support';
  if (/خرید|فروش|طلا|نقره|شمش/.test(title)) return 'silver';
  if (/کاربر|پروفایل|کودک/.test(title)) return 'person';
  return 'receipt';
}

export function InternalTitle({icon, title, eyebrow, id, level: Tag = 'h1'}) {
  return <div className="qi-title">
    <HeadingArt name={icon || titleArt(title)} size={48}/>
    <div>{eyebrow && <p>{eyebrow}</p>}<Tag id={id}>{title}</Tag></div>
  </div>;
}

const adminCopy = {
  settlements: ['وصول فیش‌های بانکی', 'فیش‌های تأیید اولیه را تا وصول وجه یا رد نهایی پیگیری کنید.'],
  dashboard: ['نمای کلی قلک', 'آمار حساب‌ها و درخواست‌های در انتظار بررسی، یک‌جا.'],
  kids: ['مدیریت مکعب کیدز', 'مدارک و نسبت والد و کودک را بررسی کنید؛ نتیجه برای خانواده نمایش داده می‌شود.'],
  buys: ['درخواست‌های خرید نقره', 'جزئیات سفارش و رسید پرداخت را پیش از تأیید بررسی کنید.'],
  sells: ['درخواست‌های فروش نقره', 'مقدار نقره، مبلغ و وضعیت هر درخواست را اینجا ببینید.'],
  barbuy: ['درخواست‌های خرید شمش', 'سفارش‌ها را بر اساس وضعیت بررسی و پیگیری کنید.'],
  copperbuy: ['درخواست‌های خرید مس', 'فیش، وزن و مبلغ خرید را بررسی و وصول وجه را تأیید کنید.'],
  goldbuy: ['درخواست‌های خرید طلا', 'وزن، مبلغ و رسید هر سفارش را کنار هم بررسی کنید.'],
  bars: ['مدیریت شمش‌ها', 'محصول‌ها، وزن و نرخ عرضهٔ شمش را مدیریت کنید.'],
  charges: ['درخواست‌های شارژ کیف پول', 'مبلغ و رسید واریز را با اطلاعات درخواست تطبیق دهید.'],
  withdrawals: ['درخواست‌های برداشت', 'حساب مقصد، مبلغ و نتیجهٔ پرداخت را دنبال کنید.'],
  ibans: ['بررسی حساب‌های بانکی', 'اطلاعات بانکی و نام صاحب حساب را پیش از تأیید تطبیق دهید.'],
  deliveries: ['درخواست‌های تحویل', 'از بررسی نشانی تا ثبت کد رهگیری، وضعیت ارسال را دنبال کنید.'],
  tickets: ['گفت‌وگوهای پشتیبانی', 'پیام کاربران را بخوانید و پاسخ هر موضوع را در همان گفت‌وگو ثبت کنید.'],
  users: ['مدیریت کاربران', 'حساب موردنظر را پیدا کنید و اطلاعات و سوابقش را ببینید.'],
  logs: ['گزارش فعالیت‌ها', 'زمان، مسئول و جزئیات فعالیت‌های ثبت‌شده را بررسی کنید.'],
  settings: ['تنظیمات قلک', 'نرخ‌ها، قوانین و دسترسی‌ها را از بخش مربوط مدیریت کنید.'],
};

export function AdminPageIntro({view}) {
  const [title, text] = adminCopy[view] || adminCopy.dashboard;
  return <header className="qi-admin-intro">
    <InternalTitle icon={internalArt[view]} eyebrow="مدیریت قلک مکعب" title={title}/>
    <p>{text}</p>
  </header>;
}
